export default function initVideoThumb() {
    const videoThumbs = document.querySelectorAll(".mb-thumb-video");

    for (let i = 0; i < videoThumbs.length; i++) {
      const video = videoThumbs[i];
      let playPromise = false;
      video.muted = true;
      video.pause();

      video.addEventListener("mouseover", function () {
        playPromise = video.play();
      });

      video.addEventListener("mouseout", function () {
        if (playPromise !== undefined) {
          playPromise.then(_ => {
            video.pause();
            playPromise = false;
          })
          .catch(error => {
          });
        }
        video.removeAttribute("controls");
      });
    }
  }
